import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { configActions } from "./configSlice";

/**
 * Fetches partner feature-set config on every page landing
 * (send/calculator, send/review, /history).
 */
export const useFeatureSet = () => {
  const dispatch = useAppDispatch();
  const featureSet = useAppSelector((state) => state.config.featureSet);

  useEffect(() => {
    dispatch(configActions.fetchFeatureSetRequested());
  }, [dispatch]);

  return featureSet;
};
